// Re-renders an Aquafeed element from the HTML Dawn fetches on variant change.
// Dawn only refreshes the elements it knows by id, so ours listen themselves.
class AqRefresh extends HTMLElement {
  connectedCallback() {
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== this.dataset.section) return;
      const fresh = data.html.getElementById(this.id);
      if (fresh) this.innerHTML = fresh.innerHTML;
    });
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }
}

if (!customElements.get('aq-refresh')) customElements.define('aq-refresh', AqRefresh);
